export default __webpack_public_path__ + "static/mAdhar-cf8830b0d24889f7b362db394abb1a8d.png";